/** The role catalog is org-scoped (`GET /orgs/{org}/authz/roles`). */
export const rolesKeys = {
  list: (organizationId: string) =>
    ["resources", organizationId, "roles", "list"] as const,
};
